<template>
  <div>
    <breadcrumbs></breadcrumbs>
    <div class="ind-title lh50 f16">
      <!-- <i class="el-icon-loading"></i> -->
      发货参数设置
    </div>

    <el-form label-width="100px" class="demo-ruleForm">
      <el-form-item label="最少发货数量" prop="name">
        <el-input v-model="add"></el-input>
      </el-form-item>
    </el-form>

    <el-button style="margin: 30px 10px" type="primary" @click="getaddlst()"
      >确定</el-button
    >
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      add: "",
      ds: "",
      pri: "",
      type: "",

      ruleForm: [{ name: "你好" }],
    };
  },

  created() {
    this.getadd();
  },

  methods: {
    getaddlst() {

        var opId = sessionStorage.getItem('opId');
      this.$api.activitymsg
        .editWarnCount({
          opId: opId,
          warnCount: this.add,
          // ds: this.ds,
          // pri: this.pri,
          // type: this.type,
        })
        .then((e) => {
          if (e.code == 200) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
          }
          this.getadd();
        });
    },

    getadd() {
        var aopId = sessionStorage.getItem('opId');
      this.$api.activitymsg
        .getWarnCount1({
          opId:aopId,
        })
        .then((e) => {
          this.add = e.data
          // this.ds = e.data.ds;
          // (this.pri = e.data.pri), (this.type = e.data.type);
        });
    },
  },
};
</script>

<style scoped></style>
